import React, { useState, useEffect } from 'react';
import ProductCard from '../components/ProductCard';
import { Button } from '../components/ui/button';
import { ArrowRight, Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const Produtos = () => {
  const [produtos, setProdutos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProdutos = async () => {
      try {
        const response = await fetch(`${API_URL}/api/public/products`);
        if (!response.ok) throw new Error('Erro ao carregar produtos');
        const data = await response.json();
        setProdutos(data);
      } catch (err) {
        console.error('Erro:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProdutos();
  }, []);

  return (
    <div className="min-h-screen bg-[#1a1a1a] pt-20">
      {/* Hero Section - Clean */}
      <section className="relative h-[50vh] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 z-0"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1674788851120-c32360e4168c?w=1920)',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        />
        <div className="absolute inset-0 z-0 bg-gradient-to-b from-[#1a1a1a]/80 via-[#1a1a1a]/60 to-[#1a1a1a]" />
        
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 z-10 text-center">
          <p className="text-[#B8860B] text-sm tracking-[0.3em] uppercase mb-4">Catálogo</p>
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-semibold text-[#E8DDCB] mb-6" style={{fontFamily: "'Playfair Display', serif"}}>
            Produtos
          </h1>
          <div className="w-16 h-[2px] bg-[#B8860B] mx-auto" />
        </div>
      </section>

      {/* Grid de Produtos */}
      <section className="py-20 bg-[#1a1a1a]">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="flex items-center justify-center py-20">
              <Loader2 className="w-8 h-8 text-[#B8860B] animate-spin" />
              <span className="ml-3 text-[#E8DDCB]/70">A carregar produtos...</span>
            </div>
          ) : error ? (
            <div className="text-center py-20">
              <p className="text-red-400">{error}</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {produtos.map((produto) => (
                <ProductCard key={produto.id} produto={produto} />
              ))}
            </div>
          )}
        </div>
      </section>

      {/* CTA Eventos */}
      <section className="py-20 bg-[#242424]">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1708388064322-c15cca1f86a7?w=800"
                alt="Eventos"
                className="w-full h-[400px] object-cover rounded-lg"
              />
              <div className="absolute -bottom-4 -left-4 w-full h-full border border-[#B8860B]/30 rounded-lg -z-10" />
            </div>
            <div className="space-y-6">
              <p className="text-[#B8860B] text-sm tracking-[0.3em] uppercase">Catering</p>
              <h2 className="text-4xl font-semibold text-[#E8DDCB]" style={{fontFamily: "'Playfair Display', serif"}}>
                Soluções para Eventos
              </h2>
              <div className="w-16 h-[2px] bg-[#B8860B]" />
              <p className="text-[#E8DDCB]/80 text-lg leading-relaxed">
                Torne o seu evento inesquecível com as nossas opções especiais de catering. Oferecemos menus personalizados e serviço completo.
              </p>
              <Button 
                asChild
                size="lg"
                className="bg-[#B8860B] hover:bg-[#D4A84B] text-[#1a1a1a] font-semibold tracking-wider uppercase text-sm px-8 py-6"
              >
                <a href="/contacto">
                  Solicitar Orçamento
                  <ArrowRight className="ml-2 w-4 h-4" />
                </a>
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Produtos;
